export class DpgModel {
    dpgId: number;
    dpgTypeId: number;
    textualReference: string;
    imoHazardClassId: number;
    unNumber: string;
    packingGroup: string;
    flashPoint: number;
    marpolCategoryId: number;
    marpolOilType: string;
    dpgType: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/dpg-model.ts